import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { propShape } from '../../../../../helpers/custom-prop-types';
import { getPosition } from '../../../../../helpers/profile';
import Image from '../../../../Ui/Common/Image';
const ProfessionalUnitProfessionalThumbnail = (props) => {
    const { professional } = props;
    const { photo } = professional;
    const position = useMemo(() => getPosition({ information: professional }, false, true), [professional]);
    return (_jsxs("div", Object.assign({ className: 'thumbnail_box' }, { children: [_jsx(Image, { alt: '', className: 'thumbnail_image', isObjectFit: true, noImageType: 'user', src: photo, useImage: true }), _jsx("div", Object.assign({ className: clsx('position_row', !position && 'is-no-position') }, { children: _jsx("span", Object.assign({ className: 'position_text' }, { children: position })) }))] })));
};
ProfessionalUnitProfessionalThumbnail.propTypes = {
    professional: propShape().isRequired,
};
export default ProfessionalUnitProfessionalThumbnail;
